import { NotificationsPage } from "./notifications";

export const Notifications = NotificationsPage;
